import * as React from 'react';
import {Switch, Route} from 'react-router-dom';

import {PageContainer} from '../../../layout';

import {QuoteTemplatePage} from './quote-template-page';

export function QuoteTemplateRoot() {
    return (
        <Switch>
            <Route
                path='/setup/quote-template'
                render={(routeProps) => {
                    return (
                        <PageContainer title='Quote Template' whiteBackground={true}>
                            {/* @ts-expect-error */}
                            <QuoteTemplatePage {...routeProps} />
                        </PageContainer>
                    );
                }}
            />
            <Route
                path='/sales/quote-template'
                // @ts-expect-error
                render={(routeProps) => <QuoteTemplatePage {...routeProps} />}
            />
        </Switch>
    );
}
